export default "__VITE_ASSET__235210be__"